<template>
  <div class="home" ref="main">
    <!-- banner -->
    <div style="padding-left: 5px">
      <div class="banner" v-if="bannerList&&bannerList.length">
        <Carousel
          autoplay
          v-model="value"
          loop
          :autoplay-speed="3000"
          @on-click="(index) => toUrl(bannerList[index].jumpUrl)"
        >
          <CarouselItem v-for="item in bannerList" :key="item.id" :style="{ height: bannerHeight + 'px' }">
            <!-- <div class="demo-carousel">
              <img :src="item.pcPic" alt style="width: 100%" />
            </div> -->
            <div
              ref="imgHeight"
              class="pic"
              :style="{ backgroundImage: 'url(' + item.pcPic + ')' }"
            >
              <!-- <a :href="item.url" target="_blank"> </a> -->
            </div>
          </CarouselItem>
        </Carousel>
      </div>

      <Row :gutter="10">
        <Col :span="userInfo.userType == 4 ? '8' : '6'" class="box-item">
          <div>
            <div class="box-item-title">总客户(位)</div>
            <div class="box-item-sum">
              <!-- 假数据 -->
              {{ numObj.totalPeople }}
              <!-- 8641 -->
            </div>
            <div class="box-item-explain" v-if="userInfo.userType == 4">
              我的客户总人数
            </div>
            <div class="box-item-explain" v-else>
              本机构及下级机构客户总人数
            </div>

            <img
              src="../../static/images/home/client.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
        <Col :span="userInfo.userType == 4 ? '8' : '6'" class="box-item">
          <div>
            <div class="box-item-title">总保费(元)</div>
            <div class="box-item-sum">
              <!-- 假数据 -->
              {{ moneyFormat("totalFee") }}
              <!-- 27,961,326.46 -->
            </div>
            <div class="box-item-explain" v-if="userInfo.userType == 4">
              我的历史总保费
            </div>
            <div class="box-item-explain" v-else>
              本机构及下级机构历史总保费
            </div>
            <img
              src="../../static/images/home/expense.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
        <Col :span="userInfo.userType == 4 ? '8' : '6'" class="box-item">
          <div>
            <div class="box-item-title">总收入(元)</div>
            <div class="box-item-sum">
              <!-- 假数据 -->
              {{ moneyFormat("totalIncome") }}
              <!-- 16,846,475.42 -->
            </div>
            <div class="box-item-explain" v-if="userInfo.userType == 4">
              我的历史总收入
            </div>
            <div class="box-item-explain" v-else>
              本机构及下级机构历史总收入
            </div>
            <img
              src="../../static/images/home/income.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
        <Col span="6" class="box-item" v-if="userInfo.userType != 4">
          <div>
            <div class="box-item-title">总净收入(元)</div>
            <div class="box-item-sum">
              <!-- 假数据 -->
              {{ moneyFormat("totalResidualIncome") }}
              <!-- 9,648,954,65 -->
            </div>
            <div class="box-item-explain">本机构历史总净收入</div>
            <img
              src="../../static/images/home/generalIncome.png"
              class="box-item-icon"
              alt=""
            />
          </div>
        </Col>
      </Row>
    </div>

    <!-- 昨日数据统计 -->
    <div class="mathList hotList" style="margin-top: 10px">
      <div class="data-statistics">
        <!-- :class="{ active: activeIndex == 1 }" -->
        <div class="left item data-statistics-title" @click="toggleTab(1)">
          昨日数据统计
        </div>
        <!-- <div class="center item" :class="{active:activeIndex==2}" @click="toggleTab(2)">本月数据统计</div> -->
        <div class="data-statistics-info">数据截止至昨日 24 : 00</div>
      </div>
      <div class="statistics-details">
        <div class="statistics-details-info">
          <div>较上一日</div>
          <div>昨日数据</div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">新增保单(份)</div>
          <div class="statistics-details-data-sum">
            <!-- 假数据 -->
            {{ numObj.newNumber || 0 }}
            <!-- 9216 -->
          </div>
          <div v-if="numObj.compareNumber == -200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareNumber >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.compareNumber >= 0 ? 'sum-red' : 'sum-green'"
              >{{
                Math.abs(
                  parseInt(numObj.compareNumber ? numObj.compareNumber : 0)
                )
              }}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">新增保费(元)</div>
          <div class="statistics-details-data-sum">
            <!-- 假数据 -->
            {{ moneyFormat("newFee") }}
            <!-- 976,565.64 -->
          </div>
          <div v-if="numObj.compareFee == -200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareFee >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.compareFee >= 0 ? 'sum-red' : 'sum-green'"
              >{{
                Math.abs(parseInt(numObj.compareFee ? numObj.compareFee : 0))
              }}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">
            预计收入(元)
            <Tooltip
              max-width="100px"
              :content="
                userInfo.userType == 4
                  ? '业务员待结算费用'
                  : '包含当前登录机构及其下级机构团队的预计收入'
              "
            >
              <!-- 包含当前登录机构及其下级机构团队的预计收入 -->
              <i class="iconfont iconwenhao1 hint"></i>
            </Tooltip>
          </div>
          <div class="statistics-details-data-sum">
            <!-- 假数据 -->
            {{ moneyFormat("newIncome") }}
            <!-- 576,655.67 -->
          </div>
          <div v-if="numObj.compareIncome == -200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareIncome >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.compareIncome >= 0 ? 'sum-red' : 'sum-green'"
              >{{
                Math.abs(
                  parseInt(numObj.compareIncome ? numObj.compareIncome : 0)
                )
              }}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data" v-if="userInfo.userType != 4">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">
            预计净收入(元)
            <Tooltip
              max-width="200"
              content="预计收入减去下级机构团队收入后的利润"
            >
              <i class="iconfont iconwenhao1 hint"></i>
            </Tooltip>
          </div>
          <div class="statistics-details-data-sum">
            <!-- 假数据 -->
            {{ moneyFormat("newResidualIncome") }}
            <!-- 376,755.54 -->
          </div>
          <div v-if="numObj.compareResidualIncome == -200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.compareResidualIncome >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span
              :class="
                numObj.compareResidualIncome >= 0 ? 'sum-red' : 'sum-green'
              "
              >{{
                Math.abs(
                  parseInt(
                    numObj.compareResidualIncome
                      ? numObj.compareResidualIncome
                      : 0
                  )
                )
              }}%</span
            >
          </div>
        </div>
        <div class="statistics-details-data">
          <div class="statistics-line"></div>
          <div class="statistics-details-data-title">
            新增客户(位)

            <Tooltip
              max-width="200"
              :content="
                userInfo.userType == 4
                  ? '业务员新增客户人数'
                  : '本级及下级机构新增客户人数'
              "
            >
              <!-- 客户指投保人,包括当前登录机构及下级机构团队的投保人 -->
              <i class="iconfont iconwenhao1 hint"></i>
            </Tooltip>
          </div>
          <div class="statistics-details-data-sum">
            <!-- 假数据 -->
            {{ numObj.newPeople }}
            <!-- 1645 -->
          </div>
          <div v-if="numObj.comparePeople == -200">-</div>
          <div v-else>
            <img
              src="../../static/images/home/goUp.png"
              v-if="numObj.comparePeople >= 0"
              alt=""
            />
            <img src="../../static/images/home/decline.png" v-else alt="" />
            <span :class="numObj.comparePeople >= 0 ? 'sum-red' : 'sum-green'"
              >{{
                Math.abs(
                  parseInt(numObj.comparePeople ? numObj.comparePeople : 0)
                )
              }}%
            </span>
          </div>
        </div>
      </div>

      <!-- <template slot-scope="{ row, index }" slot="isDown">
              <Switch v-model="row.switch" />
          </template>-->
      <!-- <div class="setTables">
        <Table
          :columns="columns"
          :data="tableDate"
          disabled-hover
          v-if="tableDate"
        >
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <div @click="showEdit(row)">
                <span class="icon icon-edit"></span>
                <span>编辑</span>
              </div>
              <div @click="showRecourse(row)">
                <span class="icon icon-edit"></span>
                <span>资料</span>
              </div>
              <div @click="showGrade(row)">
                <span class="icon icon-edit"></span>
                <span>档次</span>
              </div>
              <div @click="showCommission(row)">
                <span class="icon icon-edit"></span>
                <span>费用</span>
              </div>
            </div>
          </template>
        </Table>
      </div> -->
    </div>

    <!-- 保单保费统计 -->
    <div class="premiumStatistics" style="padding-left: 5px">
      <Row :gutter="10">
        <Col span="14">
          <div
            class="premium-item"
            :style="{ height: userInfo.userType == 4 ? '165px' : '260px' }"
          >
            <div class="data-statistics premium-title">
              <div class="left item data-statistics-title">
                保单保费统计
                <Tooltip
                  max-width="100px"
                  style="font-weight: 100"
                  content="本机构及所有下级机构/团队保单数及保费"
                >
                  <i class="iconfont iconwenhao1 hint"></i>
                </Tooltip>
              </div>

              <div
                @click="
                  $router.push({
                    path: '/orderManage/insuredOrder/order',
                    query: {},
                  })
                "
                class="look_more"
              >
                <span>查看更多</span>
                <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
              </div>
            </div>
            <div>
              <Row>
                <Col :span="userInfo.levelCode == 10005 ? '12' : '8'">
                  <div class="statistics-item">
                    <div>
                      <div class="statistics-item-sum">
                        {{
                          parseInt(
                            premiumCount.allPolicyNum
                              ? premiumCount.allPolicyNum
                              : 0
                          )
                        }}
                      </div>
                      <div class="statistics-item-info">
                        <span v-if="userInfo.userType == 4">保单数(份)</span>
                        <span v-else>全部保单(份)</span>
                      </div>
                      <div class="premium-line"></div>
                    </div>
                    <div v-if="userInfo.userType != 4">
                      <div class="statistics-item-sum">
                        {{
                          premiumCount.allPayedAmount
                            ? premiumCount.allPayedAmount
                            : 0
                        }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                      <div class="premium-line"></div>
                    </div>
                  </div>
                </Col>
                <Col :span="userInfo.levelCode == 10005 ? '12' : '8'">
                  <div class="statistics-item">
                    <div v-if="userInfo.userType != 4">
                      <div class="statistics-item-sum">
                        {{
                          parseInt(
                            premiumCount.groupPolicyNum
                              ? premiumCount.groupPolicyNum
                              : 0
                          )
                        }}
                      </div>
                      <div class="statistics-item-info">直属团队保单(份)</div>
                    </div>
                    <div>
                      <div
                        v-if="userInfo.userType == 4"
                        class="statistics-item-sum"
                      >
                        {{ premiumFormat("allPayedAmount") }}
                      </div>
                      <div v-else class="statistics-item-sum">
                        {{ premiumFormat("groupPayedAmount") }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                      <div
                        class="premium-line"
                        v-if="userInfo.levelCode != 10005"
                      ></div>
                    </div>
                  </div>
                </Col>
                <Col span="8" v-if="userInfo.levelCode != 10005">
                  <div class="statistics-item">
                    <div v-if="userInfo.userType != 4">
                      <div class="statistics-item-sum">
                        {{
                          parseInt(
                            premiumCount.orgPolicyNum
                              ? premiumCount.orgPolicyNum
                              : 0
                          )
                        }}
                      </div>
                      <div class="statistics-item-info">下级机构保单(份)</div>
                    </div>
                    <div v-if="userInfo.userType != 4">
                      <div class="statistics-item-sum">
                        {{ premiumFormat("orgPayedAmount") }}
                      </div>
                      <div class="statistics-item-info">已支付保费(元)</div>
                    </div>
                    <div v-if="userInfo.userType == 4">
                      <div class="statistics-item-sum">
                        {{ premiumFormat("refundedAmount") }}
                      </div>
                      <div class="statistics-item-info">退保保费(元)</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
        <Col span="10">
          <div
            class="premium-item"
            :style="{ height: userInfo.userType == 4 ? '165px' : '260px' }"
          >
            <div class="data-statistics premium-title">
              <div class="left item data-statistics-title">
                客户
                <Tooltip
                  max-width="100px"
                  :content="
                    userInfo.userType == '4'
                      ? '我的总客户人数'
                      : '本机构及所有下级机构/团队客户'
                  "
                  style="font-weight: 100"
                >
                  <i class="iconfont iconwenhao1 hint"></i>
                </Tooltip>
              </div>
              <div
                @click="
                  $router.push({ path: '/customerManage/list', query: {} })
                "
                class="look_more"
              >
                <span>查看更多</span>
                <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
              </div>
            </div>
            <div>
              <Row>
                <Col span="12">
                  <div
                    class="client-item"
                    :style="{
                      height: userInfo.userType == 4 ? '100px' : '200px',
                    }"
                  >
                    <div>
                      <div class="client-item-sum" style="color: #236dff">
                        {{ clientCount.isSuccessCount }}
                      </div>
                      <div class="statistics-item-info">已成交客户(位)</div>
                    </div>
                    <div class="premium-line"></div>
                  </div>
                </Col>
                <Col span="12">
                  <div
                    class="client-item"
                    :style="{
                      height: userInfo.userType == 4 ? '100px' : '200px',
                    }"
                  >
                    <div>
                      <div class="client-item-sum" style="color: #ed0000">
                        {{ clientCount.isErrorCount }}
                      </div>
                      <div class="statistics-item-info">未成交客户(位)</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>

    <!-- 热销 -->
    <div
      class="hotList"
      style="margin-top: 0; margin-top: 10px; margin-bottom: 15px"
    >
      <div class="data-statistics premium-title">
        <!-- <div class="left item data-statistics-title">最新公告</div> -->
        <Tabs v-model="noticeTabValue" @on-click="changeNoticeTab">
          <TabPane :label="item.label" :name="item.value" v-for="(item,index) in noticeTab" :key="index"></TabPane>
        </Tabs>

        <div
          @click="$router.push({ path: '/home/chatMange', query: {} })"
          class="look_more"
        >
          <span>查看更多</span>
          <i class="iconfont iconchakangengduojiantou fontjiantou"></i>
        </div>
      </div>

      <div class="list clearfix" v-if="list && list.length > 0">
        <div
          class="left"
          @click="goDetail(list[0])"
          v-if="list[0]"
        >
          <div class="imgBox">
            <img src="../../static/images/home/notice-pic.png" />
          </div>
          <div class="textArea">
            <div class="title">{{ list[0].title }}</div>
            <div>
              <div class="tag" style="display: none">xxx</div>
              <div class="other" style="margin-top: 10px; margin-bottom: 20px">
                {{ list[0].summary }}
              </div>
              <!-- <div class="other">特疾保障</div> -->
            </div>

            <div class="bot">
              <div class>{{ list[0].sendTime | filterTime("YYYY-MM-DD") }}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div
            class="item clearfix notice_item"
            v-for="(item, index) in list.slice(1, 4)"
            @click="goDetail(item)"
          >
            <div class="head">{{ item.title }}</div>
            <div class="time">
              {{ item.sendTime | filterTime("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
      </div>
      <no-data v-else></no-data>
    </div>
  </div>
</template>
<script>
import {
  getIndexData,
  chatMangeList,
  getBannerList,  
  getHolderCount,
  getAllPolicyStatistics,
} from "@/api/httpList";
import { mapState } from "vuex";
import filters from "@/api/filter";

let vm;
//当前实例组件
export default {
  data: () => ({
    bannerList: [],
    list: [],
    activeIndex: 1,
    value: 0,
    numObj: "",
    columns: [],
    tableDate: [
      {
        name: "111",
      },
    ],
    clientCount: {
      isErrorCount: 0,
      isSuccessCount: 0,
    },
    premiumCount: {
      allPayedAmount: 0,
      allPolicyNum: 0,
      groupPayedAmount: 0,
      groupPolicyNum: 0,
      orgPayedAmount: 0,
      orgPolicyNum: 0,
      refundedAmount: 0,
    },
    bannerHeight: 0,
    noticeTabValue:'1',
    noticeTab:[
      {
        label:'我的公告',
        value:'1'
      },
      {
        label:'平台公告',
        value:'2'
      },
    ]
  }),
  components: {},
  computed: {
    ...mapState(["userInfo"]),
    moneyFormat() {
      return (key) => filters.number_format(this.numObj[key], 2, ".", ",");
    },
    premiumFormat() {
      return (key) =>
        filters.number_format(this.premiumCount[key], 2, ".", ",");
    },
  },
  created() {
    this.getData();
  },
  methods: {
    // 重置banner高度
    setBannerHeight() {
      if(!this.$refs.main){
        return;
      }
      this.$nextTick(()=>{
       if (this.$refs.main.clientWidth) {
          this.bannerHeight = this.$refs.main.clientWidth / (1600/220) + "";
        } else {
          this.bannerHeight = 200;
        }
      })
    },

    changeNoticeTab(value) {
      if(value=='1'){
        chatMangeList({ pageNo: 1, pageSize: 4 }).then((res) => {
          this.list = res.data;
        });
      }else{
        chatMangeList({ pageNo: 1, pageSize: 4, source: '2' }).then((res) => {
          this.list = res.data;
        });
      }
    },

    async getData() {
      const client_res = await getHolderCount();
      this.clientCount = client_res.data;

      const premium_res = await getAllPolicyStatistics();
      this.premiumCount = premium_res.data;
    },
    goDetail(item) {
      window.open('/home/detail?id='+item.id)
      // 修改读取状态
      this.$http({
        type: "get",
        url: "/buz/noticeConfig/read/msg",
        data:{
          id:item.id
        }
      }).then(()=>{
        window.parent.postMessage({
          reloadReadNum: true,
          appMessage: true,
        }, "*");
      })
    },
    toUrl(url) {
      if (url) {
        var a = document.createElement("a");
        var event = new MouseEvent("click");
        a.href = url;
        a.target = "_blank";
        a.dispatchEvent(event);
      }
    },
    toggleTab(num) {
      this.activeIndex = num;
      this.init();
    },
    async init() {
      const res = await getIndexData(this.activeIndex);
      this.numObj = res.data;
    },
  },
  mounted() {
    // 设置banner高度
    this.setBannerHeight();
    window.onresize = () => {
      this.setBannerHeight();
    };

    chatMangeList({ pageNo: 1, pageSize: 4 }).then((res) => {
      this.list = res.data;
    });
    const news = sessionStorage.getItem("news");
    if (news) {
      this.$router.push("/home/chatMange");
      sessionStorage.removeItem("news");
    }
    getBannerList().then((res) => {
      this.bannerList = res.data;
    });
    vm = this;
    this.init();
    this.columns = [
      {
        title: " ",
        align: "center",
        render(h) {
          const txt = vm.activeIndex == 1 ? "较上一日" : "较上个月";
          const txt2 = vm.activeIndex == 1 ? "昨日数据" : "本月数据";
          return (
            <div class="headeTop">
              <div>{txt2}</div>
              <div>{txt}</div>
            </div>
          );
        },
      },
      {
        title: "新增保单（份）",
        key: "name",
        align: "center",
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareNumber > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareNumber != "-200.00" &&
              parseInt(vm.numObj.compareNumber) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newNumber}</div>
                <div
                  class={{
                    rate: true,
                    up: +vm.numObj.compareNumber > 0,
                    down: +vm.numObj.compareNumber < 0,
                    gray:
                      vm.numObj.compareNumber == "-200.00" ||
                      vm.numObj.compareNumber == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareNumber == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareNumber) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        title: "新增保费（元）",
        key: "name",
        align: "center",
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareFee > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareFee != "-200.00" &&
              parseInt(vm.numObj.compareFee) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newFee}</div>

                <div
                  class={{
                    rate: true,
                    up: +vm.numObj.compareFee > 0,
                    down: +vm.numObj.compareFee < 0,
                    gray:
                      vm.numObj.compareFee == "-200.00" ||
                      vm.numObj.compareFee == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareFee == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareFee) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        key: "name",
        align: "center",
        renderHeader: (h, params) => {
          let text = "包含当前登录机构及其下级机构团队的预计收入";
          if (vm.userInfo.userType == 4) {
            text = "业务员待结算费用";
          }
          return (
            <div>
              <span>预计收入 (元)</span>
              <Poptip
                placement="top"
                transfer={true}
                trigger="hover"
                content={text}
              >
                <span
                  class="iconfont iconwenhao"
                  style="margin-left:4px;margin-top:-2px;color:#B1B5B9;font-size:14px;"
                ></span>
              </Poptip>
            </div>
          );
        },
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareIncome > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareIncome != "-200.00" &&
              parseInt(vm.numObj.compareIncome) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newIncome}</div>
                <div
                  class="rate up gray"
                  class={{
                    rate: true,
                    up: +vm.numObj.compareIncome > 0,
                    down: +vm.numObj.compareIncome < 0,
                    gray:
                      vm.numObj.compareIncome == "-200.00" ||
                      vm.numObj.compareIncome == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareIncome == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareIncome) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        key: "jsr",
        align: "center",
        renderHeader: (h, params) => {
          return (
            <div>
              <span>预计净收入 (元)</span>
              <Poptip
                placement="top"
                transfer={true}
                trigger="hover"
                content="预计收入减去下级机构团队收入后的利润"
              >
                <span
                  class="iconfont iconwenhao"
                  style="margin-left:4px;margin-top:-2px;color:#B1B5B9;font-size:14px;"
                ></span>
              </Poptip>
            </div>
          );
        },
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.compareResidualIncome > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.compareResidualIncome != "-200.00" &&
              parseInt(vm.numObj.compareResidualIncome) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newResidualIncome}</div>
                <div
                  class={{
                    rate: true,
                    up: +vm.numObj.compareResidualIncome > 0,
                    down: +vm.numObj.compareResidualIncome < 0,
                    gray:
                      vm.numObj.compareResidualIncome == "-200.00" ||
                      vm.numObj.compareResidualIncome == 0,
                  }}
                >
                  {status}
                  {vm.numObj.compareResidualIncome == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.compareResidualIncome) + "%"}
                </div>
              </div>
            );
          }
        },
      },
      {
        // title: "新增客户（位）",
        renderHeader: (h, params) => {
          let text = "客户指投保人,包括当前登录机构及下级机构团队的投保人";
          if (vm.userInfo.userType == 4) {
            text = "业务员新增投保人数";
          }
          return (
            <div>
              <span>新增客户 (位)</span>
              <Poptip transfer={true} trigger="hover" placement="top">
                <div slot="content">
                  <div>{text}</div>
                </div>
                <span
                  class="iconfont iconwenhao"
                  style="margin-left:4px;margin-top:-2px;color:#B1B5B9;font-size:14px;"
                ></span>
              </Poptip>
            </div>
          );
        },
        key: "name",
        align: "center",
        render(h) {
          let status = "";
          //  <span class="icon icon-arrow_up arrow "></span>
          if (+vm.numObj.comparePeople > 0) {
            status = <span class="icon icon-arrow_up arrow "></span>;
          } else {
            if (
              vm.numObj.comparePeople != "-200.00" &&
              parseInt(vm.numObj.comparePeople) != 0
            ) {
              status = <span class="icon icon-arrow_down arrow "></span>;
            }
          }
          if (vm.numObj) {
            return (
              <div class="tableItem">
                <div class="numTitle">{vm.numObj.newPeople}</div>
                <div
                  class="rate up gray"
                  class={{
                    rate: true,
                    up: +vm.numObj.comparePeople > 0,
                    down: +vm.numObj.comparePeople < 0,
                    gray:
                      vm.numObj.comparePeople == "-200.00" ||
                      vm.numObj.comparePeople == 0,
                  }}
                >
                  {status}
                  {vm.numObj.comparePeople == "-200.00"
                    ? "--"
                    : Math.abs(vm.numObj.comparePeople) + "%"}
                </div>
              </div>
            );
          }
        },
      },
    ];
    if (this.userInfo.userType == 4) {
      this.columns = this.columns.filter((item) => {
        return item.key != "jsr";
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.banner {
  margin-bottom: 10px;
  .pic {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center top;

    a {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}

.chatBox {
  margin-top: 10px;
  margin-left: 10px;
  /deep/ .secondTab {
    .ivu-tabs-bar {
      border-bottom: none !important;
    }
    .ivu-tabs-ink-bar {
      height: 0 !important;
    }
  }
  ul {
    padding: 20px;
    padding-top: 0;
    background: #fff;
    li {
      padding: 20px 0;
      border-top: 1px dashed #eee;
      font-size: 16px;
      color: #333;
      span:nth-child(1) {
        float: left;
      }
      span:nth-child(2) {
        float: right;
        color: #8a9095;
      }
    }
  }
}
/deep/ .ivu-poptip-popper {
  z-index: 100000000000000;
}
/deep/ .ivu-carousel-dots li button {
  background: #fff;
}
/deep/ .numTitle {
  font-size: 20px;
}
/deep/ .rate {
  font-size: 16px;
}
/deep/ .gray {
  color: #aaa !important;
}
@import "./home.scss";
.box-item {
  position: relative;
}
.box-item > div {
  width: 100%;
  height: 180px;
  background: #fff;
  background: rgba(253, 253, 253, 1);
  border-radius: 4px;
}
/deep/.ivu-row {
  margin-left: 0 !important;
}
.box-item-title {
  width: 100%;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #515c6f;
  padding-left: 30px;
  height: 65px;
  line-height: 70px;
}
.box-item-sum {
  font-size: 32px;
  font-family: Arial;
  font-weight: bold;
  color: #3c464f;
  padding-left: 30px;
}
.box-item-explain {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #8a9095;
  padding-left: 30px;
  margin-top: 10px;
}
.box-item-icon {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 25px;
  top: 15px;
}
/deep/ .ivu-tabs-tab {
  padding-top: 0 !important;
  font-size: 14px;
}

/deep/ .ivu-tabs-bar {
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: none;
  border-bottom:none;
}
.data-statistics {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
}
.data-statistics-title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #272933;
  margin-left: 20px;
}
.data-statistics-info {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #8a9095;
  margin-left: 20px;
}
.statistics-details {
  display: flex;
}
.statistics-details > div {
  height: 150px;
  position: relative;
  // border-left: 1px solid #EEEEEE;
}
.statistics-details-info {
  width: 15%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #727c8e;
}
.statistics-details-info div:first-child {
  margin-bottom: 31px;
}
.statistics-details-info div:last-child {
  margin-bottom: 16px;
}
.statistics-details-data {
  width: 21%;
}
.statistics-details-data > div {
  text-align: center;
  margin-top: 8px;
}
.statistics-details-data-title {
  margin-top: 25px !important;
  font-size: 14px;
  font-family: PingFang SC;
  letter-spacing: 1px;
  color: #515c6f;
}
.hint {
  font-size: 14px;
  font-weight: 100;
  color: rgb(177, 181, 185);
}
.statistics-details-data-sum {
  font-size: 24px;
  font-family: Arial;
  font-weight: bold;
  color: #3c464f;
}
.sum-green {
  color: #3cb500;
  font-size: 14px;
  font-family: Arial;
}
.sum-red {
  color: #ff7134;
  font-size: 14px;
  font-family: Arial;
}
.statistics-line {
  width: 1px;
  height: 54px;
  background: #eeeeee;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -13px !important;
}
.statistics-details-data > div:last-child img {
  width: 8px;
  height: 10px;
  margin-right: 5px;
}
.statistics-details-data > div:last-child {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.premium {
  height: 200px;
}
.premiumStatistics {
  margin-left: 2px;
  margin-top: 10px;
}
.premium-item {
  width: 100%;
  // height: 165px;
  // height: 260px;
  background: #fff;
}
.premium-title {
  justify-content: space-between;
}
.premium-title > div:last-child {
  margin-right: 20px;
  color: #8a9095;
  font-size: 14px;
  font-family: PingFang SC;
  cursor: pointer;
}
.statistics-item {
  width: 100%;
  height: 100%;
  position: relative;
}
.statistics-item > div {
  width: 100%;
  height: 95px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.statistics-item div div {
  width: 100%;
  text-align: center;
}
.statistics-item-sum {
  font-size: 24px;
  font-family: Arial;
  font-weight: bold;
  color: #3c464f;
}
.statistics-item-info {
  font-size: 14px;
  font-family: PingFang SC;
  color: #515c6f;
}
.premium-line {
  width: 1px !important;
  height: 54px;
  background: #eeeeee;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -27px !important;
}
.client-item {
  width: 100%;
  // height: 100px;
  // height: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.client-item-sum {
  font-size: 24px;
  font-family: Arial;
  font-weight: bold;
  line-height: 28px;
  margin-bottom: 5px;
}
.client-item > div div {
  width: 100%;
  text-align: center;
}
.textArea:hover div {
  color: #236dff !important;
}
// .head:hover {
//   color: #236DFF !important;
// }
.notice_item:hover div {
  color: #236dff !important;
}
.fontjiantou {
  font-size: 12px;
  margin-left: 4px;
  transform: scale(0.7);
}
.look_more {
  height: 100%;
  display: flex;
  align-items: center;
}
.look_more i {
  position: relative;
  top: 1px;
}
.look_more:hover i {
  color: #236dff;
}
.look_more:hover span {
  color: #236dff;
}
/deep/.ivu-tooltip-inner {
  background: rgba(0, 0, 0, 0.9);
  font-size: 12px;
}
</style>
